import { render, staticRenderFns } from "./ReleasesNotes.vue?vue&type=template&id=c4b89a02&scoped=true&"
import script from "./ReleasesNotes.vue?vue&type=script&lang=js&"
export * from "./ReleasesNotes.vue?vue&type=script&lang=js&"
import style0 from "./ReleasesNotes.vue?vue&type=style&index=0&id=c4b89a02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b89a02",
  null
  
)

export default component.exports